import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import YandexDiskSearchModal from './YandexDiskSearchModal';

const MoveToLayoutingWarningModal = ({
  show,
  onClose,
  problematicOrderPositions,
  selectedPositionIds,
  setSelectedPositionIds,
  onConfirm,
}) => {
  const [showSearchModal, setShowSearchModal] = useState(false);

  const problematicCount = problematicOrderPositions?.length || 0;
  const hasProblems = problematicCount > 0;

  const handleContinue = () => {
    const idsToRemove = (problematicOrderPositions || []).map((p) => p.id);
    const newSelected = selectedPositionIds.filter(
      (id) => !idsToRemove.includes(id)
    );

    setSelectedPositionIds(newSelected);
    onClose();
    onConfirm(newSelected);
  };

  const articles = (problematicOrderPositions || []).map((p) => p.article);

  return (
    <>
      <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>Передача на компоновку</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {hasProblems ? (
            <>
              <p className="mb-2">
                ⚠️ Следующие позиции не могут быть переданы на компоновку,
                так как у них отсутствует товар или макет:
              </p>
              <textarea
                className="form-control mb-3"
                readOnly
                rows={Math.min(problematicCount, 10)}
                value={articles.join('\n')}
              />
              <p>
                <Button
                  variant="success"
                  onClick={() => setShowSearchModal(true)}
                >
                  Найти макеты на Яндекс Диске
                </Button>
              </p>
              <p>
                Они будут исключены из передачи. Продолжить с остальными (
                {selectedPositionIds.length - problematicCount}) позициями?
              </p>
            </>
          ) : (
            <p>Подтвердить передачу выбранных позиций на компоновку?</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Отмена
          </Button>
          <Button variant="primary" onClick={handleContinue}>
            Продолжить
          </Button>
        </Modal.Footer>
      </Modal>

      <YandexDiskSearchModal
        show={showSearchModal}
        onHide={() => setShowSearchModal(false)}
        articles={articles}
      />
    </>
  );
};

export default MoveToLayoutingWarningModal;